import { Component } from '@angular/core';
import { AppService } from './app.service'
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'home-header',
    providers: [AppService],
    template: `<div class="container" >

                <foo-details></foo-details>
                <ngx-spinner size="medium" [type]="typeSelected"></ngx-spinner>
            </div>`
})

export class HomeComponent {

    constructor(
        private _service: AppService, private spinnerService: NgxSpinnerService) { }

    typeSelected: string;

    async ngOnInit() {
        this.spinnerService.show();
        this._service.checkCredentials();
        this.spinnerService.hide();
    }

    logout() {
        this._service.logout();
    }
}